import React, { Component } from 'react';
import '../../App.css';
import Dimensions from 'react-dimensions';
import ReactPlayer from 'react-player';
import TelevisionBreakpoint from "../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../components/responsive_utilities/phone_breakpoint";
const sancoLogo = require('../../media/sancoIcon_trans.png');

var firebase = require('firebase/app');
require('firebase/database');

const videos = [
      {
        videoTitle: 'Bisbees 2017',
        clipUrl: 'https://youtu.be/qwlm-AZjsok'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: '2017 Bisbees Black & Blue Marlin Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=WuHKEpdA154' 
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: 'Bisbees 2016',
        clipUrl: 'https://www.youtube.com/watch?v=VCsB-abHMXA'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: 'Bisbees Black & Blue 2015',
        clipUrl: 'https://www.youtube.com/watch?v=p8cyCAhtPjs'
      },
       {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: '2014 Bisbees Black & Blue Marlin Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=MwOKpBxBkVk'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Inaugural PELAGIC ROCKSTAR! Tuna Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=_B4_dO0lZt8'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: '2018 Pelagic Triple Crown of Fishing - Cabo Summer Slam',
        clipUrl: 'https://www.youtube.com/watch?v=8TGlmHzdGeg&t=14s'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: 'Pelagic Triple Crown of Fishing - Cabo Summer Slam',
        clipUrl: 'https://www.youtube.com/watch?v=S3kt7VJVZS8'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
    ];


class Fishermans extends Component {
  
  constructor() {
    super();
    this.state = {
			nextVideo: '',
      currentVideo: '',
			vidPlaying: true,
			vidList: [],
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this); 
		this.baseRef = firebase.database().ref('/');
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("keyup", this.keyHandling);
		this.baseRef.child('refresh').on('child_changed', this.reloadPage);
		this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
		this.fetchVideosList();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("keyup", this.keyHandling);
  }
	
	reloadPage(){
    window.location.reload(true);
  }
	
	reloadPlaylist = () => {
		console.log('Reloading')
    this.fetchVideosList();
  }
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU';
		const channelID = 'PLBE2HTUQ9kZv6rvoeN9n_DxCF6dqSPW82';
		const results = 50;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.unshift({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
			console.log('Vids: ', vidList)
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    } else if(e.keyCode === 227) {
      this.previousVideo(this.state.currentVideo)
    } else if(e.keyCode === 228) {
      this.nextVideo(this.state.currentVideo)
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  nextVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videolist[next]
    })
  }

  previousVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var previous = index - 1;
    } else {
      var previous = 0;
    }
    this.setState({
      currentVideo: videolist[previous]
    })
  }
  
  render() {
		if(this.state.currentVideo.desc) {
			var currentVideoDesc = this.state.currentVideo.desc.slice(0, 50);
		}
		
    return (
      <div
        className='wrapper'
        width= {this.state.width}
        height= {this.state.height} >
			<TelevisionBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlay'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={90} width={200}/>
            </div>
            <div className='vidTitle'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDesc'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={45} width={100}/>
            </div>
            <div className='vidTitleDesktop'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDescDesktop'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</DesktopBreakpoint>
				<TabletBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={45} width={100}/>
            </div>
            <div className='vidTitleDesktop'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDescDesktop'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</TabletBreakpoint>
				<PhoneBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width='100%'
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayPhone'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={30} width={60}/>
            </div>
            <div className='vidTitlePhone'>
                {this.state.currentVideo.title}
								<div className='vidDescPhone'>
									{currentVideoDesc}
							</div>
            </div>
          </div> : null }
				</PhoneBreakpoint>
      </div>
    );
  }
}

export default Fishermans;



// WEBPACK FOOTER //
// ./src/pages/restaurants/Fishermans.js